interface TracksHeaderProps {
  totalCount: number;
  assignedCount: number;
}

export default function TracksHeader({
  totalCount,
  assignedCount,
}: TracksHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-[16px] font-medium text-[var(--color-black-10)] tracking-[-0.32px] leading-normal">
        Tracks{" "}
        <span className="text-[var(--color-black-5)] text-[12px] tracking-[-0.24px] leading-normal">
          ({assignedCount}/{totalCount})
        </span>
      </h1>
    </div>
  );
}
